<div class="dialog-layout-wrapper">
  <ion-header class="dialog-layout-header ion-no-border">
    <ion-toolbar [color]="toolbarColor">
      <ion-title>
        {{ title }}
      </ion-title>
      <ion-buttons slot="end" class="ion-margin-horizontal">
        <ion-button (click)="close()">
          <fa-icon [icon]="['fal', 'xmark-large']" slot="icon-only"></fa-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-toolbar *ngIf="displaySearch" color="primary">
      <ion-searchbar
        (ionInput)="search($event)"
        mode="ios"
        [placeholder]="filterText || 'Zoeken...'"
        [debounce]="searchDebounce"
        [type]="searchInputType"
        #searchbar
      ></ion-searchbar>
    </ion-toolbar>
  </ion-header>
  <div class="dialog-layout-content">
    <ng-content></ng-content>
  </div>
  <ng-content select="[slot=bottom-content]"></ng-content>
  <div
    *ngIf="displayBottomButtons && displayBottomButtonsFixedAndTransparent"
    class="dialog-layout-actions"
    style="position: fixed; bottom: 0; left: 0; right: 0; display: flex; justify-content: space-between; background: linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.5)); backdrop-filter: blur(1px); z-index: 1000; margin-right: 16px;"
  >
    <div style="display: flex; justify-content: end; gap: 16px">
      <ng-content select="[slot=left-buttons]"></ng-content>
    </div>
    <div style="display: flex; justify-content: end; gap: 16px">
      <ion-button
        mode="ios"
        *ngFor="let btn of buttons"
        [color]="btn.color"
        (click)="btn.func()"
      >
        {{ btn.label }}
      </ion-button>
      <ion-button mode="ios" type="submit" (click)="save()">
        {{ saveText || 'Opslaan' }}
      </ion-button>
    </div>
  </div>
  <div
  *ngIf="displayBottomButtons && !displayBottomButtonsFixedAndTransparent"
  class="dialog-layout-actions"
  style="width: 100%; display: flex; justify-content: space-between"
  >
  <div style="display: flex; justify-content: end; gap: 16px">
    <ng-content select="[slot=left-buttons]"></ng-content>
  </div>
  <div style="display: flex; justify-content: end; gap: 16px">
    <ion-button
      mode="ios"
      *ngFor="let btn of buttons"
      [color]="btn.color"
      (click)="btn.func()"
    >
      {{ btn.label }}
    </ion-button>
    <ion-button mode="ios" type="submit" (click)="save()">
        {{ saveText || 'Opslaan' }}
      </ion-button>
    </div>
  </div>
</div>
